import Cookies from 'js-cookie';
import jwtDecode from 'jwt-decode'
import { Message, MessageBox } from "element-ui";
import CryptoJS from "crypto-js"
import { filePath } from "@/api/Url.js";
import store from '@/store';

const loadImgHandler = (e) => {
    let data = e.currentTarget.data;
    if (e.type !== 'error') {
        data.resultList.push(e.currentTarget.cloneNode(false));
    }
    data.num++;
    if (data.num > data.list.length - 1) {
        e.currentTarget.removeEventListener("load", loadImgHandler);
        if (data.callback) {
            data.callback(data.resultList);
        }
        data = null;
        return;
    }
    e.currentTarget.src = data.list[data.num];
}

// 判断内容是否为空
const isNull = (data) => {
    let type = Object.prototype.toString.call(data)
    if (data == 'undefined' || data == 'null') {
        return true
    }
    if (!data && !type.includes('Boolean') && !type.includes('Number') && !type.includes('String')) {
        return true
    }
    if (type.includes('Object')) {
        return Object.keys(data)?.length == 0;
    }
    if (type.includes('Array')) {
        return data?.length == 0;
    }
    if (type.includes('String')) {
        return data?.trim() == '';
    }
    if (type.includes('Number')) {
        return false;
    }
    if (type.includes('Boolean')) {
        return false;
    }
}

export const method = {
    setImageBedPath: (path) => {
        if (!isNull(path)) {
            let filePath_path = path.replace(/{filePath}/g, filePath);
            if (store.state.supportWebP) {
                filePath_path = filePath_path.replace(/\.(jpg|jpeg|png)/g, '.webp');
            }
            return filePath_path;
        } else {
            return '';
        }
    },
    imageUrlToPath: (str) => {
        var regex = new RegExp(filePath, 'g');
        var newStr = str.replace(regex, '{filePath}');
        return newStr;
    },
    // 加密
    encryptAES: (message) => {
        return CryptoJS.AES.encrypt(message, process.env.VUE_APP_API_KEY).toString();
    },
    // 解密
    decryptAES: (encryptedMessage) => {
        const bytes = CryptoJS.AES.decrypt(encryptedMessage, process.env.VUE_APP_API_KEY);
        return bytes.toString(CryptoJS.enc.Utf8);
    },
    // 设置页面数据对象
    saveCookieData: (path, key, data) => {
        if (path && key && data) {
            let cookieData = Cookies.get(`auth-${path}`);
            if (cookieData) {
                cookieData = JSON.parse(cookieData);
            } else {
                cookieData = {};
            }
            cookieData[key] = data;
            Cookies.set(`auth-${path}`, JSON.stringify(cookieData));
        }
    },
    getCookieData: (path) => {
        // 获取页面数据对象
        if (path) {
            let cookieData = Cookies.get(`auth-${path}`);
            if (cookieData) {
                return JSON.parse(cookieData);
            } else {
                return null;
            }
        }
    },
    removeCookieKey: (path, key) => {
        // 删除单个页面数据对象
        if (path && key) {
            let cookieData = Cookies.get(`auth-${path}`);
            if (cookieData) {
                cookieData = JSON.parse(cookieData);
                if (cookieData[key]) {
                    delete cookieData[key];
                    Cookies.set(`auth-${path}`, JSON.stringify(cookieData));
                }
            }
        }
    },
    removeCookieData: (path) => {
        // 删除整个页面对象数据
        if (path) {
            Cookies.remove(`auth-${path}`);
        }
    },
    // 判断内容是否为空
    isNull: isNull,
    // 判断数据是否为空
    dataIsNull: (data, contrast) => {
        for (let key in contrast) {
            if (isNull(data[key])) {
                return {
                    flag: false,
                    msg: contrast[key],
                };
            }
        }
        return {
            flag: true,
            msg: '成功',
        }
    },
    // 弹出成功信息
    Message_success(message) {
        Message({
            showClose: true,
            message: message,
            type: 'success'
        });
    },
    // 弹出警告信息
    Message_warning(message) {
        Message({
            showClose: true,
            message: message,
            type: 'warning'
        });
    },
    // 弹出错误提示
    Message_error(message) {
        Message({
            showClose: true,
            message: message,
            type: 'error'
        });
    },
    // 拷贝数据
    copyData(data) {
        return JSON.parse(JSON.stringify(data));
    },
    // 深拷贝数据
    deepCopy(obj) {
        if (obj === null || typeof obj !== 'object') {
            return obj;
        }

        let copy = Array.isArray(obj) ? [] : {};

        for (let key in obj) {
            if (obj.hasOwnProperty(key)) {
                copy[key] = deepCopy(obj[key]);
            }
        }

        return copy;
    },
    // 监听图片加载
    loadImageEnd: (list, callback, basePath) => {
        if (!list || list.length === 0) return;
        if (basePath) list = list.map(item => basePath + item);
        let img = new Image();
        img.data = {
            list: list,
            callback: callback,
            resultList: [],
            num: 0
        }
        img.addEventListener("load", loadImgHandler);
        img.addEventListener("error", loadImgHandler);
        img.src = list[img.data.num];
    },
    // 获取时间
    getTime: (flag) => {
        var date = new Date();
        var year = date.getFullYear();    //  返回的是年份
        var month = date.getMonth() + 1;  //  返回的月份上个月的月份，记得+1才是当月
        var dates = date.getDate();       //  返回的是几号
        var day = date.getDay();          //  周一返回的是1，周六是6，但是周日是0
        var h = date.getHours();          //  周一返回的是1，周六是6，但是周日是0
        var m = date.getMinutes();          //  周一返回的是1，周六是6，但是周日是0
        var s = date.getSeconds();          //  周一返回的是1，周六是6，但是周日是0
        var arr = ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六",];
        let data = {};
        if (flag) {
            data = {
                year: year,
                month: month < 10 ? `0${month}` : month,
                dates: dates < 10 ? `0${dates}` : dates,
                day: arr[day],
                h: h < 10 ? `0${h}` : h,
                m: m < 10 ? `0${m}` : m,
                s: s < 10 ? `0${s}` : s,
            }
        } else {
            data = {
                year: year,
                month: month,
                dates: dates,
                day: arr[day],
                h: h,
                m: m,
                s: s,
            }
        }

        return data
    },
    // 转换为'yyyy-MM-dd HH:mm:ss'
    dateFtt: (oldDate) => {
        function add0(num) { return num < 10 ? '0' + num : num } // 个位数的值在前面补0
        const date = new Date(oldDate)
        const Y = date.getFullYear()
        const M = date.getMonth() + 1
        const D = date.getDate()
        const h = date.getHours()
        const m = date.getMinutes()
        const s = date.getSeconds()

        const dateString = Y + '-' + add0(M) + '-' + add0(D) + ' ' + add0(h) + ':' + add0(m) + ':' + add0(s)
        return dateString;
    },
    // 获取日期
    getTimeDay: (time) => {
        if (!isNull(time)) {
            let timeArr = time.split(" ");
            return timeArr[0]
        } else {
            return time;
        }
    },
    // 计算时间
    formatDate: (inputDate) => {
        const currentDate = new Date();
        const inputDateObj = new Date(inputDate);

        if (isNaN(inputDateObj)) {
            return '无效的日期';
        }
        const todayStart = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
        const todayEnd = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() + 1);
        todayEnd.setHours(0, 0, 0, 0);

        const yesterdayStart = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() - 1);
        yesterdayStart.setHours(0, 0, 0, 0);
        const yesterdayEnd = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
        yesterdayEnd.setHours(0, 0, 0, 0);

        if (inputDateObj >= todayStart && inputDateObj < todayEnd) {
            return '今天';
        } else if (inputDateObj >= yesterdayStart && inputDateObj < yesterdayEnd) {
            return '昨天';
        } else if (inputDateObj >= new Date(yesterdayStart - 86400000) && inputDateObj < yesterdayStart) { // 昨天的00:00:00之前就是前天
            return '前天';
        } else {
            let inputDateArr = inputDate.split(" ");
            return inputDateArr[0]
        }
    },
    // 返回顶部
    scrollToTop() {
        let finished_time = 200;
        let interval_time = 10;
        let scrollTop = window.pageYOffset;
        let top_pixel = scrollTop / finished_time * interval_time;
        let timer = setInterval(() => {
            scrollTop -= top_pixel;
            window.scrollTo(0, scrollTop);
            if (scrollTop <= 0) {
                clearInterval(timer)
            }
        }, interval_time)
    },
    // 设置搜索历史
    setSearchHistory: (text) => {
        let data = localStorage.getItem('searchHistoryCharhoo');
        if (!isNull(data)) {
            data = JSON.parse(data);
            if (data.indexOf(text) != -1) {
                data.splice(data.indexOf(text), 1);
                data.unshift(text);
            } else {
                data.unshift(text);
            }
        } else {
            data = [];
            data.push(text);
        }
        localStorage.setItem('searchHistoryCharhoo', JSON.stringify(data));
    },
    // 删除搜索历史
    delSearchHistory: (text) => {
        let data = localStorage.getItem('searchHistoryCharhoo');
        if (!isNull(data)) {
            data = JSON.parse(data);
            if (data.indexOf(text) != -1) {
                data.splice(data.indexOf(text), 1);
            }
        }
        localStorage.setItem('searchHistoryCharhoo', JSON.stringify(data));
    },
    // 清空搜索历史
    clearSearchHistory: () => {
        localStorage.setItem('searchHistoryCharhoo', JSON.stringify([]));
    },
    // 获取搜索历史
    getSearchHistory: () => {
        let data = localStorage.getItem('searchHistoryCharhoo');
        if (!isNull(data)) {
            data = JSON.parse(data);
            return data;
        } else {
            return [];
        }
    },
    // 获取数组最小值索引
    getMinValueIndex: (arr, method) => {
        let min = arr[0]; // 假设数组的第一个元素是最小值
        let minIndex = 0;

        for (let i = 1; i < arr.length; i++) {
            if (arr[i] < min) {
                min = arr[i];
                minIndex = i;
            }
        }

        if (!isNull(method)) {
            method(minIndex);
        }

        return minIndex;
    },
    // 格式化数字
    formatNumber: (number) => {
        let formattedNumber = '0';
        if (!isNull(number)) {
            if (number >= 10000) {
                formattedNumber = (number / 10000).toFixed(1) + '万';
            } else {
                formattedNumber = number;
            }
        }
        return formattedNumber;
    },
    supportsWebP: (callback) => {
        var img = new Image();
        img.onload = function () {
            // 如果WebP图片成功加载，则认为支持
            callback(true);
        };
        img.onerror = function () {
            // 如果WebP图片加载失败，则认为不支持
            callback(false);
        };
        img.src = 'data:image/webp;base64,UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA';
    }
}